

/**
 * “#”：数字占位符。只显有意义的零而不显示无意义的零。小数点后数字如大于”#”的数量，则按”#”的位数四舍五入。
  ”0”：数字占位符。如果单元格的内容大于占位符，则显示实际数字，如果小于点位符的数量，则用0补足。
   ”.”：小数点
   ”，”：千位分隔符
 * @param {*} template 
 * @param {*} number 
 * @returns 
 */
export const numberFormat = (number = '',template = '###', ) => {
    template = String(template);
    number = String(number);
    let modifiedNum,
        tepRadixLocal = template.indexOf('.'),
        numRadixLocal = number.indexOf('.'),
        tepZeroLenght = template.slice(tepRadixLocal + 1).length,
        numZeroLenght = number.slice(numRadixLocal + 1).length;

    //根据模板处理,数字确保小数点后位数满足要求  
    //模板有小数,值没有小数   
    if (tepRadixLocal != -1 && numRadixLocal == -1) {
        //补零
        modifiedNum = number + '.'+generateStr('0',tepZeroLenght);
        //模板有小数,值有小数   
    } else if (tepRadixLocal != -1 && numRadixLocal != -1) {
        //模板小数长度<数组小数长度
        if (tepZeroLenght < numZeroLenght) {
            //整数+模板长度四舍五入
            modifiedNum = number.substring(0, numRadixLocal + 1) + 
            roundRadix(number.substring(numRadixLocal + 1), tepZeroLenght);
        } else if (tepZeroLenght > numZeroLenght) {
            //差的小数位补零
            modifiedNum = number + generateStr('0',tepZeroLenght - numZeroLenght);
        } else if (tepZeroLenght == numZeroLenght) {
            modifiedNum = number;
        }
        //模板没有小数
    } else if (tepRadixLocal == -1 && numRadixLocal != -1) {
        //取整数
        modifiedNum = number.slice(0, numZeroLenght);
        //都没有小数
    } else if (tepRadixLocal == -1 && numRadixLocal == -1) {
        modifiedNum = number;
    }


    const target = modifiedNum.split('');
    //整数部分
    let reTemp = target.slice(0, target.indexOf('.'));
    if(template.indexOf(',')!=-1){
         //整数部分,千分位
        for (let i = reTemp.length - 2; i > 0; i--) {
            if (i % 3 == 0) {
                reTemp.splice(i, 0, ',');
            }
        }
    }
    const result = reTemp.concat(target.slice(target.indexOf('.'))).join('');
    return result;

}
//生成指定长度模板字符串
const generateStr = (tpl = '0',length = 1)=>{
    const len = Number(length)
    let result = ''
    for (let i = 0; i < len; i++) {
        result = String(result) + tpl
    }
    return result;
}
//四舍五入
const  roundRadix = (number, target = '')=> {
    let arr = String(number).split('');
    let str = '';
        arr[target] >= 5 ? (arr[target - 1] = Number(arr[target - 1]) + 1) : '';
        arr = arr.slice(0, target);
    for (let i = 0; i < arr.length; i++) {
        str += arr[i]
    }
    return str;

}

export const dateFormat =  (date, fmt='yyyy-MM-dd hh:mm:ss') =>{
	date = new Date(date)
	var o = {
		"M+" : date.getMonth()+1,                 //月份
		"d+" : date.getDate(),                    //日
		"h+" : date.getHours(),                   //小时
		"m+" : date.getMinutes(),                 //分
		"s+" : date.getSeconds(),                 //秒
		"q+" : Math.floor((date.getMonth()+3)/3), //季度
		"S"  : date.getMilliseconds()             //毫秒
	};
	if(/(y+)/.test(fmt)) {
        //年替换然后根据模板长度取值
		fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
	}
    //替换其他
	for(var k in o) {
		if(new RegExp("("+ k +")").test(fmt)){
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
		}
	}
	return fmt;
}
// 将时间戳转为天、小时、分、秒的格式
export function formatTime(timestamp) {
    const now = Date.now();
    const difference = Math.abs(now - timestamp) / 1000; // 时间差，单位为秒
    
    const days = Math.floor(difference / (24 * 60 * 60));
    const hours = Math.floor((difference % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((difference % (60 * 60)) / 60);
    const seconds = Math.floor(difference % 60);
  
    let formattedTime = '';
  
    if (days > 0) {
      formattedTime += `${days}天 `;
    }
    if (days > 0 || hours > 0) {
      formattedTime += `${hours}时 `;
    }
    if (days > 0 || hours > 0 || minutes > 0) {
      formattedTime += `${minutes}分 `;
    }
    formattedTime += `${seconds}秒`;
  
    return formattedTime.trim();
  }
import {getDictlabel} from '@/app/dict'

export default {
    date:(v)=>dateFormat(v,'yyyy-MM-dd'),//日期
    datetime:(v)=>dateFormat(v),//日期时间
    time:(v)=>dateFormat(v,'hh:mm:ss'),//时间
    dateFormat:(v,ctx,t)=>dateFormat(v,t),//自定义日期时间
    number:(v)=>numberFormat(v,'#,###.##'),//数字,默认千分位,保留两位小数
    numberFormat:(v,ctx,t)=>numberFormat(v,t),//自定义格式化
    money:(v,ctx,t)=>(t||'')+dateFormat(v,'#,###.##'),//金额格式化加金额前缀
    dict:(v,ctx,t)=>getDictlabel(t,v,'')//字典格式化
}